"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconEmptyNote = function SvgIconEmptyNote(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "empty note icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Empty Note Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.684 5.009H10.316C6.82 5.009 4 7.688 4 11.006v17.992c0 3.318 2.821 5.997 6.316 5.997h6.316v5.997c0 1.1.947 2 2.105 2 .59 0 1.116-.22 1.495-.58l7.79-7.417h9.662c3.495 0 6.316-2.679 6.316-5.997V11.006c0-3.318-2.821-5.997-6.316-5.997zM10.317 7.008h27.369c2.315 0 4.21 1.8 4.21 3.998v17.992c0 2.199-1.895 3.998-4.21 3.998H27.159l-8.42 7.996v-7.996h-8.422c-2.316 0-4.21-1.8-4.21-3.998V11.006c0-2.199 1.894-3.998 4.21-3.998z"
  }));
};

var _default = SvgIconEmptyNote;
exports.default = _default;